<template>
    <div class="d-flex justify-content-center align-items-center gap-3 mt-3">
        <DButton
            id="pagination-previous"
            icon="chevron-left"
            :disabled="!hasPrevious"
            :label="__('messages.previous')"
            @click="goTo(currentPage - 1)"
        />
        <span>{{ __('messages.page', { number: currentPage }) }}</span>
        <DButton
            id="pagination-next"
            icon-after="chevron-right"
            :disabled="!hasNext"
            :label="__('messages.next')"
            @click="goTo(currentPage + 1)"
        />
    </div>
</template>

<script setup>
/**
 * Prev/next pager for the activity log.
 *
 * The activity log cannot use DPagination: counting the rows to work out a page
 * total means an unbounded COUNT(*) over activity_log, which takes over seven
 * seconds on the largest tenant. Without a total there is no `last_page`, and
 * CSmartPagination requires one.
 *
 * `hasNext` comes from the paginator's `next_page_url`, which simplePaginate()
 * derives by fetching one row beyond the page, so the button disables itself at
 * the end of the result set.
 */
import { __ } from '~@/Composables/translation'

const props = defineProps({
    currentPage: {
        type: Number,
        required: true
    },
    hasPrevious: {
        type: Boolean,
        default: false
    },
    hasNext: {
        type: Boolean,
        default: false
    }
})

const emit = defineEmits(['update:activePage'])

const goTo = (page) => {
    if (page < 1 || (page > props.currentPage && !props.hasNext) || (page < props.currentPage && !props.hasPrevious)) {
        return
    }

    emit('update:activePage', page)
}
</script>
